<template>
    <div>
        <div class="content-caption dashed">
            <span>合并单信息</span>
            <div class="shrink-tab fr" :class="showFormInfoFlag? 'current': ''" @click="doShowFormInfo()">
                <span>{{showFormInfoFlag ? '隐藏' : '展开'}}</span>
                <i :class="showFormInfoFlag? 'el-icon-arrow-down': 'el-icon-arrow-right'"></i>
            </div>
        </div>
        <template v-if="showFormInfoFlag">
            <div class="simple-form flex col-3">
                <div class="form-group">
                    <div class="form-label">
                        <label>机构名称</label>
                    </div>
                    <div class="form-value">
                        <span>{{formInfo.retailerComFullName || '无'}}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>标题</label>
                    </div>
                    <div class="form-value">
                        <span>{{formInfo.title || '无'}}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>合并单号</label>
                    </div>
                    <div class="form-value">
                        <span>{{formInfo.innerNo || '无'}}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>合并方式</label>
                    </div>
                    <div class="form-value">
                        <span>{{mergeWayMap[formInfo.mergeWay]}}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>合并原因</label>
                    </div>
                    <div class="form-value">
                        <span>{{formInfo.mergeDesc || ''}}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>合并后原值(元)</label>
                    </div>
                    <div class="form-value">
                        <span>{{parseFloat(formInfo.mergedAmount || 0).toFixed(2)}}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>资产编号</label>
                    </div>
                    <div class="form-value">
                        <span><a class="table-cell-link" @click="viewAssetInfo(formInfo);" v-if="formInfo.devcInnerCode != null && formInfo.devcInnerCode != ''">{{formInfo.devcInnerCode}}</a></span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>系统编号</label>
                    </div>
                    <div class="form-value">
                        <span>{{formInfo.devcNo || ''}}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>资产原值(元)</label>
                    </div>
                    <div class="form-value">
                        <span>{{(formInfo.orgWorth || 0).toFixed(2)}}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>资产数量</label>
                    </div>
                    <div class="form-value">
                        <span>{{formInfo.theQuantity}}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>单据创建时间</label>
                    </div>
                    <div class="form-value">
                        <span>{{formInfo.createTime}}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>状态</label>
                    </div>
                    <div class="form-value">
                        <span v-if="formInfo.applyState == 0">待申请</span>
                        <span v-if="formInfo.applyState == 1 && formInfo.auditState == 0">待审核</span>
                        <span v-if="formInfo.auditState == 1">审核通过</span>
                        <span v-if="formInfo.auditState == -1">审核未通过</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>审核人</label>
                    </div>
                    <div class="form-value">
                        <span>{{formInfo.auditorName || ''}}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>审核描述</label>
                    </div>
                    <div class="form-value">
                        <span>{{formInfo.auditDesc}}</span>
                    </div>
                </div>
            </div>
        </template>
        <div class="content-caption dashed">
            <span>新资产信息</span>
            <div class="shrink-tab fr" :class="showItemFlag? 'current': ''" @click="doShowItem()">
                <span>{{showItemFlag ? '隐藏' : '展开'}}</span>
                <i :class="showItemFlag? 'el-icon-arrow-down': 'el-icon-arrow-right'"></i>
            </div>
        </div>
        <template v-if="showItemFlag">
            <div class="table-layout" v-if="formInfo.itemList != null && formInfo.itemList.length > 0">
                <el-table :data="formInfo.itemList" border maxHeight="400" ref="dataTable" tooltip-effect="dark" :summary-method="getItemAmountSum" show-summary style="width: 100%">
                    <el-table-column align="left" prop="devcInnerCode" label="资产编号" width="160" fixed show-overflow-tooltip>
                        <template slot-scope="rows">
                            <a class="table-cell-link" @click="viewAssetInfo(rows.row);" v-if="rows.row.devcInnerCode != null && rows.row.devcInnerCode != ''">{{rows.row.devcInnerCode}}</a>
                            <span v-else>{{rows.row.devcInnerCode}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" prop="title" label="资产描述全称" width="200" fixed show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="modelSpec" label="型号规格" width="120" show-overflow-tooltip></el-table-column>
                    <el-table-column align="right" prop="theQuantity" label="数量" width="100" show-overflow-tooltip></el-table-column>
                    <el-table-column align="right" prop="orgWorth" label="原值(元)" width="150" show-overflow-tooltip>
                        <template slot-scope="rows">
                            <span v-if="rows.row.orgWorth != null">{{rows.row.orgWorth.toFixed(2)}}</span>
                            <span v-else>0.00</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="aggtDeprWorth" label="累计折旧(元)" width="150" show-overflow-tooltip>
                        <template slot-scope="rows">
                            <span v-if="rows.row.aggtDeprWorth != null">{{rows.row.aggtDeprWorth.toFixed(2)}}</span>
                            <span v-else>0.00</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="netWorth" label="净值(元)" width="150" show-overflow-tooltip>
                        <template slot-scope="rows">
                            <span v-if="rows.row.netWorth != null">{{rows.row.netWorth.toFixed(2)}}</span>
                            <span v-else>0.00</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" prop="retailerComFullName" label="所属部门" show-overflow-tooltip></el-table-column>
                </el-table>
            </div>
        </template>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes} from '../../app.vues'
    import {assetFiscalInfoDlg} from '../retailer/dialog'

    import devcApi from '../../api/devc'

    export default{
        name: 'swb-devc-merge-form-detail',
        desc: '合并单详情',
        props: ["id"],
        data: function () {
            return {
                formInfo: {},
                //
                showFormInfoFlag: true,
                showItemFlag: true,
                mergeWayMap: getEnumMap('devcMergeWay', 'value2text')
            }
        },
        created: function () {
            if (!Utils.isNoB(this.id)) {
                this.getFormInfoDetail();
            }
        },
        methods: {
            // 查看合并单详情
            getFormInfoDetail: function () {
                let self = this;
                //
                let params = {};
                params.id = self.id;
                let msgBoxDlg = MsgBox.loading();
                devcApi.getDevcMergeFormDetail(params, function (result) {
                    msgBoxDlg.close();
                    if (result.type == 'info') {
                        let formInfo = result.data || {};
                        let itemList = formInfo.itemList || [];
                        let mergedAmountX = parseFloat(formInfo.orgWorth || 0);
                        for (let i = 0, len = itemList.length; i < len; i++) {
                            let item = itemList[i];
                            mergedAmountX = mergedAmountX + parseFloat(item.orgWorth || 0);
                        }
                        formInfo.mergedAmount = mergedAmountX;
                        self.formInfo = Utils.merge({}, formInfo);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 查看资产信息
            viewAssetInfo: function (row) {
                let params = {
                    innerCode: row.devcInnerCode,
                    assetType: row.assetType
                };
                assetFiscalInfoDlg(params);
            },
            // 隐藏、展开
            doShowFormInfo: function () {
                this.showFormInfoFlag = !this.showFormInfoFlag;
            },
            // 隐藏、展开
            doShowItem: function () {
                this.showItemFlag = !this.showItemFlag;
            },
            getItemAmountSum: function (param) {
                const {columns, data} = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '合计';
                        return;
                    }
                    let flag = true;
                    let quantityFlag = false;
                    let values = data.map(item => Number(item[column.property]));
                    //
                    if (column.property == 'quantity') {
                        values = data.map(item => Number(item['quantity']));
                        quantityFlag = true;
                    } else if (column.property == 'orgWorth') {
                        values = data.map(item => Number(item['orgWorth']));
                    } else if (column.property == 'netWorth') {
                        values = data.map(item => Number(item["netWorth"]));
                    } else if (column.property == 'aggtDeprWorth') {
                        values = data.map(item => Number(item["aggtDeprWorth"]));
                    } else {
                        flag = false;
                    }
                    if (flag && !values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (quantityFlag) {
                                if (!isNaN(value)) {
                                    return prev + curr;
                                } else {
                                    return prev;
                                }
                            } else {
                                if (!isNaN(value)) {
                                    return (parseFloat(prev) + parseFloat(curr)).toFixed(2);
                                } else {
                                    return parseFloat(prev).toFixed(2);
                                }
                            }
                        }, 0);
                        if (quantityFlag) {
                            sums[index];
                        } else {
                            sums[index] += ' 元';
                        }
                    } else {
                        sums[index] = '-';
                    }
                });
                return sums;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/devcMerge/DevcMergeFormDetail.vue